export const REPORT_DATA_REFRESH_TIME = 16 * 60 * 1000;
export const MINIMUM_USERS_ON_LEADERBOARD = 3;
